import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '@/hooks/useRouter';
import User from '@/pages/_common_user/ManageUser';
import useQuery from './useQuery';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import SleepingStarting from '@/pages/_common_user/User/SleepingStarting';
import SleepingEnding from '@/pages/_common_user/User/SleepingEnding';

export default function Layout() {
  const { location } = useRouter();
  const launch = useDialogLauncher();

  const PAGE_SIZE = 12;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  const csvQuery = useQuery({
    returnCsvQuery: true
  });

  function onDownload(query) {
    launch(DialogManager.CSVDownload.Config(query));
  }

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Partners']}
      title="Sleeping Partners"
      description={(
        <span>
          These are partners with a profile that is currently sleeping. Until their profile
          wakes up, they will be hidden from search results and people will be unable to
          message them.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      csvQuery={function () {
        onDownload(csvQuery);
      }}
      row={function(user) {
        return (
          <User key={user.id} user={user}>
            <div className="bg-cs-gray-50 p-4 border-t border-cs-gray-100">
              <div className="grid grid-cols-2">
                <SleepingStarting user={user} />
                <SleepingEnding user={user} align="right" />
              </div>
            </div>
          </User>
        );
      }}
    />
  );
}
